import { apiSlice } from '@src/services/api/apiSlice';
import { CreateTicketResponse, CreateTicketRequest } from './tickets.types';

const ticketsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createTicket: builder.mutation<
            CreateTicketResponse,
            CreateTicketRequest
        >({
            query: (data) => ({
                url: '/tickets/create',
                method: 'POST',
                body: data,
            }),
        }),
    }),
});

export const { useCreateTicketMutation } = ticketsApiSlice;